import styled from "@emotion/styled";
import theme from "../../styles/theme";
import QuickFacts from "../quick-fact/quick-fact";

export const HeroFormBackground = styled.div`
  background: ${theme.colors.darkBlues[5]};
  width: 100%;
`;

export const HeroFormBase = styled.div<{ doubleColumn: boolean }>`
  padding: 28px 36px 32px;
  display: flex;
  flex-direction: column;
  max-width: 800px;
  margin: 0 auto;

  ${theme.largerThan.xl} {
    padding: 48px 5%;
  }

  ${theme.largerThan.xl} {
    ${(props) =>
      props.doubleColumn &&
      `
            max-width: ${theme.maxWidth};
            flex-direction: row;
            align-items: flex-start;
        `}
  }
`;

export const HeroText = styled.div<{ doubleColumn: boolean }>`
  flex: 1 1 auto;

  ${theme.largerThan.sm} {
    text-align: center;
  }

  ${theme.largerThan.xl} {
    ${(props) => props.doubleColumn && "text-align: initial"};
  }
`;

export const Title = styled.h1`
  margin-bottom: 16px;
`;

export const Subtitle = styled.h4`
  margin-bottom: 24px;
`;

export const StyledQuickFacts = styled(QuickFacts)<{ doubleColumn: boolean }>`
  text-align: initial;
  margin-top: 0 !important;
  margin-bottom: 0 !important;

  ${theme.largerThan.sm} {
    width: fit-content;
    margin: 0 auto 0;
  }

  ${theme.largerThan.xl} {
    ${(props) =>
      props.doubleColumn &&
      `
            width: initial;
            margin: initial;
        `}
  }
`;

export const Form = styled.div<{ doubleColumn: boolean }>`
  background: #ffffff;
  flex: 1 0 auto;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 4px;
  box-shadow: 0 0 25px 0 ${theme.colors.darkBlues[100]}15;
  margin-top: 40px;

  ${theme.largerThan.xl} {
    padding: 40px 32px;
    ${(props) =>
      props.doubleColumn &&
      `
            max-width: 420px;
            margin-top: initial;
        `};
  }
`;

export const FormTitle = styled.h4`
  color: ${theme.colors.darkBlues[90]};
  flex: 0 1 auto;
  font-size: 21px;
  text-align: center;
`;

export const FormSubtitle = styled.div`
  color: ${theme.colors.darkBlues[90]};
  font-size: 16px;
  line-height: 24px;
  flex: 0 1 auto;
  text-align: center;
  margin-bottom: 4px;
  max-width: 500px;
`;
